import React from 'react'
import { t } from 'ttag'

import pagearrow from '@h2/assets/svg/icons/pageArrow.svg'

import Form from '../../../form/Form'
import Field from '../../../form/Field'

const MultipleChoiceQuestionForm = ({
  onSave,
  onCancel,
  onGetModel,
  onAddToArray,
  onRemoveFromArray,
  onMoveInArray
}) => {
  const formModel = 'survey.surveyForms.surveyMultiChoiceQuestionForm'
  const model = path => `${formModel}.${path}`
  const _model = onGetModel(formModel)

  //console.log(_model.options)
  return (
    <Form
      model={formModel}
      onSubmit={form => {
        onSave(form)
      }}>
      {form => (
        <div>
          <Field
            model={model(`name`)}
            form={form}
            required={true}
            label={t`Question Title`}
            type="text"
          />

          <Field
            model={model(`description`)}
            form={form}
            label={t`Description`}
            type="textarea"
          />

          <Field
            model={model(`responseRequired`)}
            form={form}
            label={t`Response Required`}
            type="checkbox"
          />

          <Field
            model={model(`multipleResponses`)}
            form={form}
            label={t`Allow Multiple Responses`}
            type="checkbox"
          />

          <Field
            model={model(`noSelectionText`)}
            form={form}
            label={t`No Selection Text (eg: choose one) or blank for none`}
            type="text"
          />

          <label>Options</label>
          <ul>
            {(_model.options || []).map((f, idx) => {
              //  console.log(f, idx)
              return (
                <li style={{ listStyle: 'none' }}>
                  <div className="row">
                    <div className="col-xs-1">
                      {idx > 0 && (
                        <a
                          href="javascript:void(0)"
                          onClick={() =>
                            onMoveInArray(formModel, 'options', idx, Math.max(0, idx - 1))}>
                          <img
                            src={pagearrow}
                            style={{
                              width: '15px',
                              marginTop: '1rem',
                              transform: 'rotate(270deg)'
                            }}
                            alt={t`Up facing arrow to go to move item up`}
                          />
                        </a>
                      )}
                      {idx < _model.options.length - 1 && (
                        <a
                          href="javascript:void(0)"
                          onClick={() =>
                            onMoveInArray(
                              formModel,
                              'options',
                              idx,
                              Math.min(_model.options.length, idx + 1)
                            )}>
                          <img
                            src={pagearrow}
                            alt={t`Up facing arrow to go to move item up`}
                            style={{
                              width: '15px',
                              marginTop: '1rem',
                              marginLeft: '10px',
                              transform: 'rotate(90deg)'
                            }}
                          />
                        </a>
                      )}
                    </div>
                    <div className="col-xs-10">
                      <Field
                        model={`${formModel}.options[${idx}].label`}
                        label={t`Option ` + (idx + 1)}
                        form={form}
                        type="text"
                      />
                    </div>
                    <div className="col-xs-1">
                      <a
                        href="javascrit:void(0)"
                        className="delete"
                        onClick={() => onRemoveFromArray(formModel, 'options', idx)}>
                        <span className="sr-only">{t`Remove`}</span>
                      </a>
                    </div>
                  </div>
                </li>
              )
            })}
            <a
              href="javascript:void(0)"
              onClick={() => onAddToArray(formModel, 'options')}
              className="btn btn-default no-style">
              <i className="add">
                <span className="sr-only">+</span>
              </i>{' '}
              {t`Add Another Option`}
            </a>
          </ul>

          <div className="nav" style={{ marginTop: '1em' }}>
            <input type="submit" className="submit" value={t`Save Question`} />
            &nbsp;
            <button type="button" onClick={onCancel} className="cancel">
              {t`Cancel`}
            </button>
          </div>
        </div>
      )}
    </Form>
  )
}

export default MultipleChoiceQuestionForm
